
export default function() {
  $('.graph li').popover({
    placement: 'top',
    trigger: 'hover'
  });
  
  $('.graph li:first-child').popover('show');

  var explicationStep = 1;
  //unbind event
  var $graphActive = $('.graph li.active');

  if ($graphActive.length) {
    $graphActive.mouseenter(addActiveGraph);
  }
}

function addActiveGraph () {
  $(this).unbind('mouseenter', addActiveGraph);
  explicationStep++;
  $(this).removeClass('active');
  $('.graph li.graph_dot'+explicationStep).addClass('active');
  $graphActive = $('.graph li.graph_dot'+explicationStep);

  if ($graphActive.length)
    $graphActive.mouseenter(addActiveGraph);
}
